// ** react imports
import React from 'react';
import PropTypes from 'prop-types';

// ** component imports
import Loading from '../../common/Loading';
import InOfficeFileUploader from './components/InOfficeFileUploader';
import OfficeDocumentsHeader from './quiz/OfficeDocumentsHeader';
import TaxFileHistory from './quiz/TaxFileHistory';

// ** context imports
import {
  DocumentProvider,
  useDocument,
} from '../../../contexts/DocumentContext';

const InOfficeDocumentsSection = () => {
  return (
    <DocumentProvider>
      <DocumentSectionContent />
    </DocumentProvider>
  );
};

const DocumentSectionContent = () => {
  const {
    isHistoryMode,
    taxFileDocuments,
    isGetTaxFileDocumentsLoading,
    isGetTaxFileDocumentsFetching,
  } = useDocument();

  return (
    <section className="h-full bg-white dark:bg-gray-800 rounded-xl shadow-lg border border-gray-20 dark:border-gray-700">
      <OfficeDocumentsHeader />

      <div className="relative min-h-[calc(40vh-100px)] p-4 sm:p-6">
        {isGetTaxFileDocumentsLoading || isGetTaxFileDocumentsFetching ? (
          <div className="w-full flex items-center justify-center bg-white/50 dark:bg-gray-800/50">
            <Loading size="medium" />
          </div>
        ) : isHistoryMode ? (
          <TaxFileHistory />
        ) : (
          <InOfficeFileUploader
            initialFiles={taxFileDocuments?.documents || []}
            taxFileDocuments={taxFileDocuments}
          />
        )}
      </div>
    </section>
  );
};

InOfficeDocumentsSection.propTypes = {
  taxFile: PropTypes.object.isRequired,
};

export default InOfficeDocumentsSection;
